// Reálne čísla z produkcie (aktualizované 2026-09-23, zdroj: produkčná DB).
// Pri ďalšej aktualizácii stačí prepísať hodnoty.
const LIVE_SINCE = new Date('2025-06-29');

const monthsLive = Math.max(
  1,
  Math.floor((Date.now() - LIVE_SINCE.getTime()) / (1000 * 60 * 60 * 24 * 30.44))
);

export const LIVE_STATS = [
  { value: 3765, suffix: '', labelKey: 'stats.shifts' },
  { value: 35141, suffix: '', labelKey: 'stats.hours' },
  { value: monthsLive, suffix: '', labelKey: 'stats.months' },
];
